module.exports = __webpack_public_path__ + "as.svg?1d7901fc863b36cc55cea528a7efc460";


//////////////////
// WEBPACK FOOTER
// ./src/images/flags/1x1/as.svg
// module id = 937
// module chunks = 27